import {Instrument, TagCategory} from "../gen/api";

export enum Status {
  IDLE,
  LOADING,
  SUCCEEDED,
  FAILED,
}

type Resource<T> = {
  data: T
  status: Status
  error?: string
}

export type State = {
  tags: Resource<TagCategory[]>,
  instruments: Resource<Instrument[]>,
  isAuthenticated: boolean,
  message: Message | null
  selectedFilters: string[]
}

export type Message = {
  text: string,
  severity: Severity
}

export enum Severity {
  ERROR = "error",
  INFO = "info",
  SUCCESS = "success",
  WARNING = "warning"
}